import { Controller } from "stimulus"

export default class extends Controller {
  down(event) {
      event.preventDefault();
      let target = document.getElementById("header").nextElementSibling;
      if (target.id === 'mobileHeader') {
        target = target.nextElementSibling;
      }
      if (target) {
        target.scrollIntoView({block: "start", behavior: "smooth"});
      }
  }
}
